import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DownloadsComponent } from './pages/downloads/downloads.component';
import { HomeComponent } from './pages/home/home.component';
import { FaqComponent } from './pages/faq/faq.component';
import { ExamfeeComponent } from './pages/examfee/examfee.component';
import { InstructionsComponent } from './pages/instructions/instructions.component';
import { MobileappComponent } from './pages/mobileapp/mobileapp.component';
import { AboutcbtComponent } from './pages/aboutcbt/aboutcbt.component';
import { CrsComponent } from './pages/crs/crs.component';
import { GrsComponent } from './pages/grs/grs.component';
import { PdupComponent } from './pages/pdup/pdup.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { AdminComponent } from './pages/admin/admin.component';
import { AuthenticationGuard } from './api/authentication.guard';
import { AuthInvigilatorGuard } from './api/auth-invigilator.guard';
import { ItistateGuard } from './api/itistate.guard';
import { AuthCandidateGuard } from './api/auth-candidate.guard';
import { EriformlistComponent } from './pages/eriformlist/eriformlist.component';
import { EriformEditComponent } from './pages/eriform-edit/eriform-edit.component';
import { LayoutComponent } from './layout/layout.component';
import { EricountComponent } from './pages/ericount/ericount.component';
import { EristatusComponent } from './pages/eristatus/eristatus.component';
import { EriviewComponent } from './pages/eriview/eriview.component';
import { PdulistComponent } from './pages/pdulist/pdulist.component';
import { PdueditComponent } from './pages/pduedit/pduedit.component';
import { PduviewComponent } from './pages/pduview/pduview.component';
import { InvigidashboardComponent } from './pages/invigidashboard/invigidashboard.component';
import { EriformComponent } from './pages/eriform/eriform.component';
import { InvigiericountComponent } from './pages/invigiericount/invigiericount.component';
import { TrackidComponent } from './pages/trackid/trackid.component';
import { PriformComponent } from './pages/priform/priform.component';
import { InvigilatoradminComponent } from './pages/invigilatoradmin/invigilatoradmin.component';
import { InvigilatorviewComponent } from './pages/invigilatorview/invigilatorview.component';
import { CandidateComponent } from './pages/candidate/candidate.component';
import { CandidatedashboardComponent } from './pages/candidatedashboard/candidatedashboard.component';
import { CandidateformComponent } from './pages/candidateform/candidateform.component';
import { CandidateviewComponent } from './pages/candidateview/candidateview.component';
import { CrilistComponent } from './pages/crilist/crilist.component';
import { CrieditComponent } from './pages/criedit/criedit.component';
import { CriviewComponent } from './pages/criview/criview.component';
import { AdminreportComponent } from './pages/adminreport/adminreport.component';
import { ShippedreportsComponent } from './pages/shippedreports/shippedreports.component';
import { ShippedviewComponent } from './pages/shippedview/shippedview.component';
import { ExamcenterlistComponent } from './pages/examcenterlist/examcenterlist.component';
import { DirnimilistComponent } from './pages/dirnimilist/dirnimilist.component';
import { DirnimieditComponent } from './pages/dirnimiedit/dirnimiedit.component';
import { DirnimiviewComponent } from './pages/dirnimiview/dirnimiview.component';
import { ExamComponent } from './pages/exam/exam.component';
import { ExamformComponent } from './pages/examform/examform.component';
import { ReexamComponent } from './pages/reexam/reexam/reexam.component';
import { CbtfeepayComponent } from './pages/cbtfeepay/cbtfeepay.component';
import { ExamformstateComponent } from './pages/examformstate/examformstate.component';
import { ExamfeeitiComponent } from './pages/examfeeiti/examfeeiti.component';


import { ItiloginComponent } from './pages/CTSITI/itilogin/itilogin.component';
import { ItiotpComponent } from './pages/CTSITI/itiotp/itiotp.component';
import { ItibtnComponent } from './pages/CTSITI/itibtn/itibtn.component';
import { ShowtableComponent } from './pages/CTSITI/showtable/showtable.component';
import { PaytableComponent } from './pages/CTSITI/paytable/paytable.component';
import { ViewtableComponent } from './pages/CTSITI/viewtable/viewtable.component';
import { ShowstatetableComponent } from './pages/CTSSTATE/showstatetable/showstatetable.component';
import { ShowpaytableComponent } from './pages/CTSSTATE/showpaytable/showpaytable.component';
import { StateloginComponent } from './pages/CTSSTATE/statelogin/statelogin.component';
import { CtsctudloginComponent } from './pages/CTSSTUD/ctsctudlogin/ctsctudlogin.component';
import { ImportITIComponent } from './pages/import-iti/import-iti.component';
import { ItiexamadminComponent } from './pages/itiexamadmin/itiexamadmin.component';
import { CandidatelistComponent } from './pages/candidatelist/candidatelist.component';
import { IticodelistComponent } from './pages/iticodelist/iticodelist.component';
import { PaymentverifiedlistComponent } from './pages/paymentverifiedlist/paymentverifiedlist.component';


const routes: Routes = [
  {
    path: '', component: LayoutComponent, children: [
      { path: '', component: HomeComponent },
      { path: 'home', component: HomeComponent },
      { path: 'download', component: DownloadsComponent },
      { path: 'home', component: HomeComponent },
      { path: 'faq', component: FaqComponent },
      { path: 'examfee1', component: ExamfeeComponent },
      { path: 'itistatelogin', component: StateloginComponent },
      
      { path: 'examfeestate', component: ExamformstateComponent,  canActivate: [ItistateGuard], children: [        
        { path: 'Showstatetable', component: ShowstatetableComponent },
        { path: 'showpaytable', component: ShowpaytableComponent }
      ] },      
      // { path: 'ctsctudlogin', component: CtsctudloginComponent},
      { path: 'reexam', component: ReexamComponent},
      // { path: 'examfee', component: ExamformComponent},
      { path: 'examfeeiti', component: ExamfeeitiComponent,  children: [
        { path: 'examitilogin', component: ItiloginComponent },
        { path: 'examitiotp', component: ItiotpComponent },
        { path: 'examitibtn', component: ItibtnComponent },
        { path: 'examitishow', component: ShowtableComponent },
        { path: 'examitipay', component: PaytableComponent },
        { path: 'examitiview', component: ViewtableComponent },
      ] },
      { path: 'Instructions', component: InstructionsComponent },
      { path: 'mobileapp', component: MobileappComponent },
      { path: 'aboutcbt', component: AboutcbtComponent },
      { path: 'crs', component: CrsComponent },
      { path: 'trackId', component: TrackidComponent },
      { path: 'invigilatorAdmin', component: InvigilatoradminComponent },
      {
        path:'exam', component: ExamComponent
      },
    
      { path: 'priForm', component: PriformComponent },
      { path: 'cbtfeepay', component: CbtfeepayComponent},

      {
        path: 'invigilator_dashboard', component: InvigidashboardComponent, canActivate: [AuthInvigilatorGuard], children: [
          { path: 'invigiericount', component: InvigiericountComponent },
          { path: 'eristatus', component: EristatusComponent },
          { path: 'eriform', component: EriformComponent },
          { path: 'invigilatorview', component: InvigilatorviewComponent }
        ]
      },
      {
        path: 'dashboard', component: DashboardComponent, canActivate: [AuthenticationGuard], children: [
          { path: 'ericount', component: EricountComponent },
          { path: 'eriedit', component: EriformEditComponent },
          { path: 'erilist', component: EriformlistComponent },
          { path: 'eriview', component: EriviewComponent },
          { path: 'pdulist', component: PdulistComponent },
          { path: 'dirnimilist', component: DirnimilistComponent },
          { path: 'dirnimiedit', component: DirnimieditComponent },
          { path: 'adminreport', component: AdminreportComponent },
          { path: 'dirnimiview', component: DirnimiviewComponent },
          { path: 'pduedit', component: PdueditComponent },
          { path: 'pduview', component: PduviewComponent },
          { path: 'crilist', component: CrilistComponent },
          { path: 'criedit', component: CrieditComponent },
          { path: 'criviewadmin', component: CriviewComponent },
          { path: 'ImportITI', component: ImportITIComponent},
          { path: 'itiexam', component : ItiexamadminComponent},
          { path: 'iticodelist', component : IticodelistComponent},
          { path: 'itistudlist', component : CandidatelistComponent},
          { path: 'paymentlist', component : PaymentverifiedlistComponent}


          
        ]
      },
      { path: 'admin', component: AdminComponent },
      { path: 'verifyreport', component: ShippedreportsComponent },
      { path: 'verifyview', component: ShippedviewComponent },



      { path: 'candidate', component: CandidateComponent },
      {
        path: 'candidatedashboard', component: CandidatedashboardComponent, canActivate: [AuthCandidateGuard], children: [
          { path: 'criform', component: CandidateformComponent },
          { path: 'criview', component: CandidateviewComponent },


        ]
      },

      {
        path: 'grs', component: GrsComponent,
        children: [
          {
            path: 'pdup', // child route path
            component: PdupComponent, // child route component that the router renders
          },

        ],
      },
      { path: 'grs/pdup', component: PdupComponent },
      { path: 'examcenterlist', component: ExamcenterlistComponent}
    ]
  },

];


@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
